import {useEffect, useState} from "react";
import {Table, Tooltip, Popconfirm, Space} from "antd";
import {EditOutlined, DeleteOutlined} from "@ant-design/icons";
import MerchantService from "../../../../services/ewallet_integration/merchant.service";

const UserTable = (props) => {
    const {merchant, handleEdit, handleDelete, refresh, setRefresh} = props;
    const [state, setState] = useState({
        rows: [],
    });

    const fetchUsersListing = async () => {
        const response = await MerchantService.queryUserByMerchant(merchant?.merchant_id);
        if (response) {
            const {merchantUsers} = response?.data;
            setState(state => ({
                ...state,
                rows: merchantUsers,
            }));
        }
    };



    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Email',
            dataIndex: ['account', 'email'],
            key: 'email',
        },
        {
            title: 'Role',
            dataIndex: ['role', 'description'],
            key: 'role',
        },
        {
            title: 'Action',
            dataIndex: 'merchant_user_id',
            key: 'id',
            render: (id, record) => (
                <Space size="middle">
                    <Tooltip title="Edit">
                        <span
                            className="action-icon edit"
                            onClick={() => handleEdit(record)}
                        >
                            <EditOutlined/>
                        </span>
                    </Tooltip>

                    <Tooltip title="Delete">
                        <Popconfirm
                            title="Are you sure you want to delete this user?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => handleDelete(id)}
                        >
                            <span className="action-icon delete">
                                <DeleteOutlined/>
                            </span>
                        </Popconfirm>
                    </Tooltip>
                </Space>
            )
        }
    ];

    useEffect(() => {
        fetchUsersListing();
    }, []);

    useEffect(() => {
        if(refresh) {
            fetchUsersListing();
        }
    }, [refresh]);
    return (
        <>
            <Table
                columns={columns}
                dataSource={state?.rows}
                pagination={false}
                rowKey="merchant_user_id"
            />
        </>
    );
};

export default UserTable;
